<template>
  <div class="video-wrapper">
    <video
      :playsinline="playsinline"
      :autoplay="autoplay"
      :ref="videoRef"
      :setTime="setTime"
      :src="getVideoById(videoId)"
      :controls="controls"
      width="100%"
      height="100%"
      :loop="loop"
    ></video>
    <slot></slot>
    <DEButton
      v-if="playButton && !playing"
      class="play-button"
      @btnCallToAction="playVideo"
      :btnVariant="playBtnVariant"
      :btnVariantHover="playBtnVariantHover"
      :btnOutlineColor="playBtnOutlineColor"
      :aria-label="ariaLabelPlay"
    >
      <template v-slot:button-icon>
        <icon size="1.5em" name="play"></icon>
      </template>
    </DEButton>
    <DEButton
      v-if="pauseButton && playing"
      class="pause-button"
      @btnCallToAction="pauseVideo"
      :btnVariant="pauseBtnVariant"
      :btnVariantHover="pauseBtnVariantHover"
      :btnOutlineColor="pauseBtnOutlineColor"
      :aria-label="ariaLabelPause"
    >
      <template v-slot:button-icon>
        <icon size="1.5em" name="pause"></icon>
      </template>
    </DEButton>
    <DEButton
      v-if="startStopButton"
      class="pause-button"
      @btnCallToAction="startStopVideo"
      :btnVariant="startStopBtnVariant"
      :btnVariantHover="startStopVariantHover"
      :btnOutlineColor="pauseBtnOutlineColor"
      :aria-label="playing ? ariaLabelPause : ariaLabelPlay"
    >
      <template v-slot:button-icon>
        <icon v-if="!playing" size="1.5em" name="play"></icon>
        <icon v-else size="1.5em" name="pause"></icon>
      </template>
    </DEButton>
    <slot name="pause-button"></slot>
  </div>
</template>

<script>
import VideoPlayerMixin from '../mixins/VideoPlayerMixin';
import { Icon } from '../../Icon';
import { DEButton } from '../../Buttons';

export default {
  name: 'VideoPlayer',
  mixins: [VideoPlayerMixin],
  components: { DEButton, Icon },
};
</script>

<style lang="stylus" scoped>
.video-wrapper
  position: absolute
  top 0
  left 0
  width 100%
  height 100%
  z-index 999

video
  width 100%
  height 100%

.play-button
.pause-button
  position: absolute
  top 2.5em
  right 2.5em
  min-width 3.3em
  min-height 3.3em
  width 3.3em
  height 3.3em
  border-radius 50%
  border 0.2em solid #FFFFFF

  svg
    margin-left 0.4em
</style>
